module.exports = __webpack_public_path__ + "static/media/Lens_Card_JP.3e07f141.png";